import { SET_DOCGROUP_STATE } from './actionTypes';

export const changeDocGroupState = (state) => ({
  type: SET_DOCGROUP_STATE,
  state,
});
